<template>
	<div class="socials">
		<a v-for="medium in socials" :key="medium.ID" :class="medium.platform" :href="medium.url" target="_blank">
			<div class="social-icon" />
		</a>
	</div>
</template>

<script setup>
defineProps({
	socials: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.socials {
	display: flex;
	align-items: center;
	place-content: center flex-start;

	a {
		display: flex;
		align-items: center;
		place-content: center center;
		width: 30px;
		height: 30px;
		margin: 10px 15px 10px 0;
		text-decoration: none;
		opacity: 0.75;

		&::after {
			display: none;
		}

		&.facebook {
			background: url('~/assets/images/socials/facebook.png') no-repeat center center;
			background-size: 30px;
		}

		&.instagram {
			background: url('~/assets/images/socials/instagram.png') no-repeat center center;
			background-size: 30px;
		}

		&.linkedin {
			background: url('~/assets/images/socials/linkedin.png') no-repeat center center;
			background-size: 30px;
		}

		&.pinterest {
			background: url('~/assets/images/socials/pinterest.png') no-repeat center center;
			background-size: 30px;
		}

		&.tiktok {
			background: url('~/assets/images/socials/tiktok.png') no-repeat center center;
			background-size: 30px;
		}

		&:hover {
			opacity: 1;
		}
	}
}

@media (max-width: 680px) {
	footer .socials {
		justify-content: flex-start;
	}

	.socials {
		a {
			margin: 10px 10px 10px 0;
		}
	}
}

@media (max-width: 580px) {
	.socials {
		a {
			margin: 8px 8px 8px 0;
		}
	}
}
</style>
